import { useEffect, useRef, useState } from 'react'
import useJSPDF, { PDFInfoType } from './hooks/useJSPDF'
import './pdf.scss'
import PDFContent from './screens/PDFContent'
import { ProductDetailShortPDFWrapper } from './screens/ProductDetailShortPDF'

const PDF = () => {
  const [pdfInfo, setPdfInfo] = useState<PDFInfoType[]>([])
  const downloadStatus = useRef<{ index: number; status?: boolean }[]>([])
  const { printDocuments } = useJSPDF()
  const [downloadCount, setDownloadCount] = useState(0)
  const [hasDownloaded, setHasDownloaded] = useState(false)

  useEffect(() => {
    const queryString = new URLSearchParams(window.location.search)
    const pdfData = JSON.parse(queryString.get('data') || '[]')
    if (Array.isArray(pdfData) && pdfData.length > 0) {
      downloadStatus.current = pdfData.map((_, index) => ({ status: undefined, index }))
      setPdfInfo(pdfData)
    }
  }, [])

  const onDownloadStatus = async (index: number, result: boolean, type: string) => {
    const itemIndex = downloadStatus.current.findIndex((status) => status.index === index)
    if (itemIndex === -1) return console.error('item not found')

    downloadStatus.current[itemIndex].status = result
    const nonDownloadStatus = downloadStatus.current.filter((data) => data.status === undefined)

    if (nonDownloadStatus.length === 0 && type === 'export') {
      const validDownloads = downloadStatus.current.filter((data) => data.status === true)
      const elementIds = validDownloads.map((data) => `pdf-wrapper-id-${data.index}`)
      downloadStatus.current = []
      // await 1 second to make sure all components are rendered
      setTimeout(async () => {
        await printDocuments(elementIds, (successIndex: number) => {
          setDownloadCount(successIndex + 1)
        })
        setHasDownloaded(true)
        const isSafari = (window as any).safari !== undefined
        if (!isSafari) {
          window.close()
        }
      }, 1000)
    } else if (type === 'exportShort') {
      const validDownloads = downloadStatus.current.filter((data) => data.status === true)
      const elementIds = validDownloads.map((data) => `pdf-wrapper-id-${data.index}`)
      downloadStatus.current = []

      // Wait for 1 second to make sure all components are rendered
      setTimeout(async () => {
        await printDocuments(elementIds, (successIndex: number) => {
          setDownloadCount(successIndex + 1)
        })
        setHasDownloaded(true)
        const isSafari = (window as any).safari !== undefined
        if (!isSafari) {
          window.close()
        }
      }, 1000)
    }
  }

  const message =
    downloadCount === 0 ? 'Processing...' : `Printing (${downloadCount}/${pdfInfo.length})...`

  const hasProductDetailsShort = pdfInfo.some((info) => info.type === 'productdetailsshort')

  return (
    <div id='pdf_container'>
      {hasDownloaded ? (
        <h6>You can close the page now</h6>
      ) : (
        <>
          <h6>{message}</h6>
          <h6>Please do not close this page until the new PDF has been exported</h6>
          <div id='hidden_div'></div>
          {hasProductDetailsShort && pdfInfo.length > 0 && (
            <div id={'pdf-wrapper-id-0'}>
              <ProductDetailShortPDFWrapper
                products={pdfInfo}
                onDownloadStatus={(result: boolean) => onDownloadStatus(0, result, 'exportShort')}
              />
            </div>
          )}
          <div id='pdf_wrapper'>
            {pdfInfo.map((pdf, index) => (
              <div id={`pdf-wrapper-id-${index}`} key={`${pdf.pageId}-${index}`}>
                <PDFContent
                  type={pdf.type}
                  pageId={pdf.pageId}
                  onDownloadStatus={(result: boolean) => onDownloadStatus(index, result, 'export')}
                />
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  )
}

export default PDF
